import { ExtensionComponentProps } from 'piral'
import * as React from 'react'

export default function UserSettingsMenu(props: ExtensionComponentProps<any>) {
    return (
        <sp-menu-item href="/usersettings">
            <sp-icon-user-admin slot="icon"></sp-icon-user-admin>
            User settings
        </sp-menu-item>
    )
}
